<script lang="ts">
    import '../app.postcss'
    import { onMount, type Snippet } from 'svelte'
    import { page } from '$app/stores'
    import PageLoader from '@reijor/svelte-inputs/PageLoader.svelte'
    import SignIn from '$lib/components/SignIn.svelte'
    import { restoreSession, session, user } from '$lib/session'

    let { children }: { children?: Snippet } = $props()

    let ready = $state(false)

    const nav = [
        { href: '/', label: 'Overview' },
        { href: '/invoices', label: 'Invoices' },
        { href: '/billing', label: 'Billing' },
        { href: '/payments', label: 'Payments' },
        { href: '/banking', label: 'Banking' },
        { href: '/receipts', label: 'Receipts' },
        { href: '/vendors', label: 'Vendors' },
        { href: '/items', label: 'Items' },
        { href: '/journal', label: 'Journal' },
        { href: '/accounts', label: 'Chart of Accounts' },
        { href: '/reports', label: 'Reports' },
        { href: '/year-end', label: 'Year End' },
        { href: '/settings', label: 'Settings' }
    ]

    onMount(async () => {
        try {
            await restoreSession()
        } finally {
            ready = true
        }
    })

    function isCurrent(href: string, pathname: string): boolean {
        return href === '/' ? pathname === '/' : pathname === href || pathname.startsWith(href + '/')
    }

    async function signOut() {
        await session.logout()
    }

    let displayName = $derived($user ? [$user.firstName, $user.lastName].filter(Boolean).join(' ') || $user.email : '')
</script>

{#if !ready}
    <PageLoader message="Opening the books..."/>
{:else if !$user}
    <SignIn/>
{:else}
    <div class="min-h-screen flex flex-col bg-white">
        <!-- The nav wraps on a laptop-width window rather than pushing the whole page into a horizontal scroll. -->
        <header class="bg-primary text-white flex items-center px-6 py-2 min-h-14 shrink-0">
            <a href="/" class="flex items-center gap-3 mr-10 shrink-0">
                <img src="/books.svg" alt="" class="h-8 w-8"/>
                <span class="text-xl font-bold whitespace-nowrap">Reijor Books</span>
            </a>
            <nav class="flex flex-wrap gap-1 grow min-w-0">
                {#each nav as item (item.href)}
                    <a
                        href={item.href}
                        class="px-3 py-1 rounded whitespace-nowrap {isCurrent(item.href, $page.url.pathname) ? 'bg-white text-primary font-bold' : 'hover:bg-white/15'}"
                    >{item.label}</a>
                {/each}
            </nav>
            <span class="text-sm mr-4 whitespace-nowrap">{displayName}</span>
            <button class="sm-btn border border-white/60 px-3 hover:bg-white/15 shrink-0 whitespace-nowrap" onclick={signOut}>Sign out</button>
        </header>
        <main class="grow p-6">
            {@render children?.()}
        </main>
    </div>
{/if}
